export default __webpack_public_path__ + "static/media/coinbaseWalletIcon.07499ce0.svg";